export default "__VITE_ASSET__9270910c__$_?nuxt_component=async__"